import React from "react";
import { Icon, PlainButton } from "@culturehq/components";
import { t, Trans } from "app/utils";
import ChqModalConfirmDelete from "components/common/ChqModalConfirmDelete";
import { PromptQuestionOmitId } from "chq";
import AIQuestionModal, { AIQuestionModalProps } from "./AIQuestionModal";
import styles from "./newAIStoryQuestionModal.module.scss";

type index = number;
export interface AIQuestionOptionProps {
    index: index;
    question: PromptQuestionOmitId;
    questionsLength: number;
    onDelete: (index: index) => void;
    onUpdate: AIQuestionModalProps["onUpdate"];
}

const AIQuestionOption: React.FC<AIQuestionOptionProps> = ({
  index,
  question,
  questionsLength,
  onDelete,
  onUpdate
}) => {
  const handleAcceptDelete = () => onDelete(index);

  return (
    <div className={`row ${styles["chart-row"]}`} data-id={index}>
      <div className={`p-0 ${styles["sortable-column"]}`}>
        <div className="sortable__drag-handler" />
      </div>
      <div className={`col-sm-9 ${styles.column} prompt-title p-0`}>
        {question.question}
      </div>
      <div className={`col-sm-2 ${styles.column} ${styles.actions} align-self-end`}>
        <AIQuestionModal
          index={index}
          onUpdate={onUpdate}
          question={question}
        >
          {(onTrigger: any) => (
            <PlainButton className="Subprompt-Edit_Btn link link-ai action pull-right" onClick={onTrigger}>
              <Icon icon="edit" />
            </PlainButton>
          )}
        </AIQuestionModal>
        <ChqModalConfirmDelete
          onAccept={handleAcceptDelete}
          trigger={(onTrigger: any) => (
            <PlainButton
              aria-label={`${t("Delete")} ${question.question} ${t("option")}`}
              className={`link link-ai action ${questionsLength < 3 ? styles.action__disabled : ""} pull-right`}
              onClick={onTrigger}
              disabled={questionsLength < 3}
            >
              <Icon icon="trash-a" />
            </PlainButton>
          )}
        >
          <Trans>Are you sure you want to delete this option?</Trans>
        </ChqModalConfirmDelete>
      </div>
    </div>
  );
};

export default AIQuestionOption;
